import React from "react";
import trans from "../../../../utils";
import { Checkbox } from "antd";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import { useGetIRenumsQuery } from "../../../../Redux/service/IR/IR";
import { useGetPOIFormQuery } from "../../../../Redux/service/POIS/POIs";
import {
	useGetDisciplinesQuery,
	useGetOptionsQuery,
	useGetSectorsQuery,
	useGetSubsystemsQuery,
} from "../../../../Redux/service/Snag/Snag";
import usePermission from "../../../../hooks/usePermission";
const moduletypes = {
	IR: "IR",
	SNAG: "SNAG",
};
const ModuleForm = ({ type, addConfig }) => {
	const moduleIndex = addConfig.values.modules?.findIndex(
		(m) => m.module === type,
	);
	const { data: enums } = useGetIRenumsQuery();
	const { data: snagdiscipline } = useGetOptionsQuery();
	const { data: Forms } = useGetPOIFormQuery(
		{
			category: "IR",
			poiId: addConfig?.values?.projectId,
		},
		{ skip: !addConfig.values.projectId },
	);

	const { data: sectorsData } = useGetSectorsQuery();

	return (
		<>
			{moduletypes[type] === "IR" && (
				<>
					<InputSelect
						label="Discipline"
						id="discipline"
						name="discipline"
						placeholder={trans("Select Discipline")}
						className="w-100"
						style={{ width: "100%" }}
						formstyle="col-lg-6 mb-2"
						options={enums?.data?.disciplines?.map((i) => ({
							label: trans(i),
							value: i,
						}))}
						errors={
							moduleIndex !== -1 &&
							addConfig.errors.modules?.[moduleIndex]?.discipline
						}
						value={
							moduleIndex !== -1
								? addConfig.values.modules?.[moduleIndex]?.discipline
								: undefined
						}
						onChange={(val) =>
							addConfig.setFieldValue(`modules.${moduleIndex}.discipline`, val)
						}
						touched={
							(moduleIndex !== -1 &&
								addConfig.touched.modules?.[moduleIndex]?.discipline) ||
							addConfig.values.modules?.[moduleIndex]?.module
						}
						onBlur={() =>
							addConfig.setFieldTouched(
								`modules.${moduleIndex}.discipline`,
								true,
							)
						}
						disabled={moduleIndex === -1}
					/>
					<InputSelect
						label="Form"
						id="form"
						name="form"
						placeholder={trans("Select form")}
						className="w-100"
						style={{ width: "100%" }}
						formstyle="col-lg-6 mb-2"
						options={Forms?.data?.map((i) => ({
							label: i.name,
							value: i.id,
						}))}
						errors={
							moduleIndex !== -1 &&
							addConfig.errors.modules?.[moduleIndex]?.formId
						}
						touched={
							(moduleIndex !== -1 &&
								addConfig.touched.modules?.[moduleIndex]?.formId) ||
							addConfig.values.modules?.[moduleIndex]?.module
						}
						onBlur={() =>
							addConfig.setFieldTouched(`modules.${moduleIndex}.formId`, true)
						}
						value={
							moduleIndex !== -1
								? addConfig.values.modules?.[moduleIndex]?.formId
								: undefined
						}
						onChange={(val) =>
							addConfig.setFieldValue(`modules.${moduleIndex}.formId`, val)
						}
						disabled={moduleIndex === -1}
					/>
				</>
			)}
			{moduletypes[type] === "SNAG" && (
				<>
					<InputSelect
						label="Sector"
						id="sector"
						name="sector"
						placeholder={trans("Select Sector")}
						className="w-100"
						style={{ width: "100%" }}
						formstyle="col-lg-6 mb-2"
						options={sectorsData?.data?.map((i) => ({
							label: i.label,
							value: i.code,
						}))}
						errors={
							moduleIndex !== -1 &&
							addConfig.errors.modules?.[moduleIndex]?.sector
						}
						touched={
							(moduleIndex !== -1 &&
								addConfig.touched.modules?.[moduleIndex]?.sector) ||
							addConfig.values.modules?.[moduleIndex]?.module
						}
						onBlur={() =>
							addConfig.setFieldTouched(`modules.${moduleIndex}.sector`, true)
						}
						value={
							moduleIndex !== -1
								? addConfig.values.modules?.[moduleIndex]?.sector
								: undefined
						}
						onChange={(val) =>
							addConfig.setFieldValue(`modules.${moduleIndex}.sector`, val)
						}
						disabled={moduleIndex === -1}
					/>

					<InputSelect
						label="Discipline"
						id="discipline"
						name="discipline"
						placeholder={trans("Select Discipline")}
						className="w-100"
						style={{ width: "100%" }}
						formstyle="col-lg-6 mb-2"
						options={snagdiscipline?.data?.disciplines?.map((i) => ({
							label: trans(i.label),
							value: i.value,
						}))}
						errors={
							moduleIndex !== -1 &&
							addConfig.errors.modules?.[moduleIndex]?.discipline
						}
						touched={
							(moduleIndex !== -1 &&
								addConfig.touched.modules?.[moduleIndex]?.discipline) ||
							addConfig.values.modules?.[moduleIndex]?.module
						}
						onBlur={() =>
							addConfig.setFieldTouched(
								`modules.${moduleIndex}.discipline`,
								true,
							)
						}
						value={
							moduleIndex !== -1
								? addConfig.values.modules?.[moduleIndex]?.discipline
								: undefined
						}
						onChange={(val) =>
							addConfig.setFieldValue(`modules.${moduleIndex}.discipline`, val)
						}
						disabled={moduleIndex === -1}
					/>
				</>
			)}
		</>
	);
};
function Module({ type, addConfig }) {
	return (
		<div
			style={{
				backgroundColor: "#EAF4EC",
				border: "1px solid #EEEEEE",
				padding: "16px",
				width: "100%",
				marginBottom: "8px",
				borderRadius: "16px",
			}}
		>
			<Checkbox
				style={{ marginBottom: "16px" }}
				checked={addConfig.values.modules?.some((m) => m.module === type)}
				onChange={(e) => {
					const isChecked = e.target.checked;
					const currentModules = addConfig.values.modules || [];

					if (isChecked) {
						// ✅ أضف module object جديد
						addConfig.setFieldValue("modules", [
							...currentModules,
							{ module: type },
						]);
					} else {
						// ❌ احذف module بالكامل
						addConfig.setFieldValue(
							"modules",
							currentModules.filter((m) => m.module !== type),
						);
					}
				}}
			>
				{trans(moduletypes[type])}
			</Checkbox>
			<div className="row">{ModuleForm({ type, addConfig })}</div>
		</div>
	);
}
export default function OfflineSetupControlModule({ addConfig }) {
	const { create: CreateIR } = usePermission("IR");
	const { create: CreateSnag } = usePermission("SNAG");

	return (
		<>
			<div style={{ paddingInline: "16px" }}>
				<div
					style={{
						color: "#0F6936",
						fontWeight: "500",
						fontSize: "16px",
						marginBottom: "16px",
					}}
				>
					{trans("Select Module")}
				</div>
				{CreateIR && <Module type="IR" addConfig={addConfig} />}
				{CreateSnag && <Module type="SNAG" addConfig={addConfig} />}
				{typeof addConfig.errors.modules === "string" && (
					<div className="validation">{addConfig.errors.modules}</div>
				)}
			</div>
		</>
	);
}
